var PopoutLooks;
(function (PopoutLooks) {
  PopoutLooks["Default"] = 'default';
  PopoutLooks["Primary"] = 'primary';
})(PopoutLooks || (PopoutLooks = {}));
var PopoutVariants;
(function (PopoutVariants) {
  PopoutVariants["None"] = '';
  PopoutVariants["Standard"] = 'standard';
})(PopoutVariants || (PopoutVariants = {}));
export { PopoutLooks, PopoutVariants };